import axios from 'axios';
import axiosRetry from 'axios-retry';
import { logger } from './logger';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: import.meta.env.VITE_SUPABASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`
  }
});

// Configure retry logic
axiosRetry(api, {
  retries: 3,
  retryDelay: (retryCount) => {
    return Math.min(1000 * Math.pow(2, retryCount), 10000);
  },
  retryCondition: (error) => {
    // Retry on network errors or 5xx server errors
    return axiosRetry.isNetworkOrIdempotentRequestError(error) || 
           (error.response?.status ?? 0) >= 500;
  },
  onRetry: (retryCount, error, requestConfig) => {
    logger.warn(`Retrying request (attempt ${retryCount})`, {
      error: error.message,
      url: requestConfig.url,
      method: requestConfig.method
    });
  }
});

// Add response interceptor for logging
api.interceptors.response.use(
  (response) => {
    logger.info('API request successful', {
      url: response.config.url,
      method: response.config.method,
      status: response.status
    });
    return response;
  },
  (error) => {
    logger.error('API request failed', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      error: error.message,
      data: error.response?.data
    });
    return Promise.reject(error);
  }
);

export { api };